/// <amd-module name="Wiki/Editor/Components/SavePageDialog" />
import * as React from "react";

import { Dialog } from "VSSUI/Dialog";
import { TextField } from "VSSUI/TextField";

import * as Resources from "Wiki/Editor/Resources";

export interface ISavePageDialogProps {
    showRenameInfo: boolean;
    withCustomMessage: boolean;
    defaultMessage?: string;
    onDismiss: (isSaved?: boolean) => void;
    savePage: (commitMessage?: string) => void;
}

interface ISavePageDialogComponentState {
    customMessage?: string;
}

export class SavePageDialog extends React.Component<ISavePageDialogProps, ISavePageDialogComponentState> {
    private static readonly _savePageClassName = "spd-save";
    private static readonly _messageInputClassName = "spd-message";

    constructor(props: ISavePageDialogProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { onDismiss, savePage, showRenameInfo, withCustomMessage, defaultMessage } = this.props;
        return (
            <Dialog
                onDismiss={onDismiss}
                titleProps={{ text: Resources.SavePageDialog_Title }}
                footerButtonProps={[
                    {
                        text: Resources.SavePageDialog_CancelLabel,
                        onClick: () => onDismiss(),
                        className: "spd-cancel"
                    },
                    {
                        text: Resources.SavePageDialog_SaveLabel,
                        onClick: () => {
                            onDismiss(true);
                            savePage(this.state.customMessage || defaultMessage);
                        },
                        primary: true,
                        className: SavePageDialog._savePageClassName
                    }
                ]}
                defaultActiveElement={"." + (withCustomMessage ? SavePageDialog._messageInputClassName : SavePageDialog._savePageClassName)}
            >
                <div className="savepage-dialog-content">
                    {showRenameInfo && <div className="spd-rename-info">{Resources.SavePageDialog_RenameInfoMessage}</div>}
                    {withCustomMessage && (
                        <TextField
                            value={this.state.customMessage}
                            onChange={this._onCustomMessageChanged}
                            placeholder={defaultMessage}
                            multiline
                            inputClassName={SavePageDialog._messageInputClassName}
                            containerClassName="spd-textfield"
                        />
                    )}
                </div>
            </Dialog>
        );
    }

    private _onCustomMessageChanged = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, value: string): void => {
        this.setState({ customMessage: value });
    };
}
